import http from '@/assets/js/http';

// 获取充值档次列表
export const getRechargeClassList = function() {
  return http.get('/v1/app/Recharge');
}

// 充值
export const postRecharge = function(data) {
  return http.post('/v1/app/Recharge', data);
}

// 获取充值状态
export const getChargeStatus = function(data) {
  return http.get(`/v1/app/Recharge/${data}`);
}
